const tableHeaders = [
  {
    label: 'Niveau',
    key: 'stepName',
    sortable: false,
  },
  {
    label: 'Nom',
    key: 'name',
    sortable: false,
  },
  {
    label: 'Poste',
    key: 'title',
    sortable: false,
  },
  {
    label: 'Date',
    key: 'createdAt',
    filter: 'date',
    sortable: false,
  },
  {
    label: 'Statut',
    key: 'result',
    sortable: false,
  },
];

export default () => tableHeaders;
